export const ENVIRONMENT_ACTION_TYPES = {
  SET_ENVIRONMENT_OPEN: 'environment/SET_ENVIRONMENT_OPEN',
  SET_ENVIRONMENT_CODE: 'environment/SET_ENVIRONMENT_CODE',
  SET_ENVIRONMENT_ITEM: 'environment/SET_ENVIRONMENT_ITEM',
  SET_ENVIRONMENT_LIST: 'environment/SET_ENVIRONMENT_LIST',
};
